import { Skeleton, Stack } from '@mantine/core';
import React from 'react';

const LoadingText = () => {
  return (
    <>
      {[...Array(5)].map((_, i) => (
        <Stack gap={4} key={i}>
          <Skeleton h={16} w={'20%'} />
          <Skeleton h={16} w={'45%'} />
        </Stack>
      ))}
    </>
  );
};

export default LoadingText;
